// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__GkHDg","meals-appear":"AvailableMeals_meals-appear__wEzNI","main-image":"AvailableMeals_main-image__Xm1xO"};